module.exports = __webpack_public_path__ + "img/growth-ic.c9b3afb7.svg";